import type { FaireProductEntity } from "../../entity_types/product";

export const p_cf3qmhrd: FaireProductEntity = {
  token: "p_cf3qmhrd",
  type: "product",
  name: "Whole San Marzano DOP Tomatoes by Italianavera",
  brandToken: "b_a9do4tt1",
  brandName: "Zia Pia",
  imageUrl:
    "https://cdn.faire.com/fastly/66a10974ffa40b44655849b3930ac8263ea3895c33c387979a4228161a88c8bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bcb871d904169006bbcf1f5654d62957abf4f988424631c5d0fceecd627cd48.png",
    "https://cdn.faire.com/fastly/fb03686020a23c96b040c47647c65bf27e53242018cb25e1d5926d61cd690417.png",
    "https://cdn.faire.com/fastly/12b1447861f1e6182381e61d1f1b85e114b946e0024e1f3d1bff5eb9d3852650.jpeg",
    "https://cdn.faire.com/fastly/26c2ea2f26ec0b09d3c92dd101b08c9bbadb5a36c3ff75a163e769d25af7e60b.jpeg",
    "https://cdn.faire.com/fastly/a9e65119887db6bdf7e5e36129aa7e7ff0c6b9a523ab07d657169e08b4c19fb4.jpeg",
    "https://cdn.faire.com/fastly/b69bae539bea3f52637d0f60b0f3ba26d8f5ec11f05ca5fbfde52ddc00e94c28.jpeg",
  ],
  priceDollars: 4,
  description:
    "San Marzano is a very delicate tomato which, when preserved properly, keeps its flavor well over time, but it must be handled with care. Cultivated in the the very fertile lands of Agro Nocerino – Sarnese, in the province of Salerno, it is recognized by the DOP. Peeled and preserved in a delicate San Marzano juice, it is ideal for preparing delicious tomato-based pasta sauces. \n\nItalianavera is an entrepreneurial, female-owned company in the San Marzano DOP area. Inspired by her childhood in the San Marzano region, owner Diana Attianese's goal was to bring the homemade tomato sauces from her youth to the rest of the world. She continues her family’s passion and tradition with San Marzano tomatoes and more authentic local varieties of tomatoes by combining fresh, pure flavors and gorgeous packaging. Read more about Italianavera. \n\nNet weight: 400 g/14.01 oz\n\nIngredients: San Marzano plum peeled tomatoes, tomato juice",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:54.586Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
